"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getWindowSize = void 0;

var getWindowSize = function getWindowSize() {
  return "undefined" == typeof window ? {
    width: 0,
    height: 0
  } : {
    width: window.innerWidth || 0,
    height: window.innerHeight || 0
  };
};

exports.getWindowSize = getWindowSize;